import { lazy } from 'react';

export const CalculatorPage = lazy(() => import('./Calculator.component'));
